import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_COMPANY_FLEX_PORTFOLIO_GET_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_COMPANY_FLEX_PORTFOLIO_GET_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_COMPANY_FLEX_PORTFOLIO_GET_API_ID,
  ({ id }) => ({
    endpoint: `/api/admin/companies/${id}/flex-portfolio`,
    method: 'GET',
  })
);

export default apiCall;
